import React from 'react'
import ActionToggle from 'live/components/ui/action-toggle'
import i18n from 'live/services/i18n'
import AssetSelector from '../editor/fields/AssetSelector'
import ObjectSelector from '../editor/fields/ObjectSelector'
import { Fields } from '../editor'
import { JsonConfig } from '../../types'
import styled from 'styled-components'
import { zoomOptions, ZoomStatus } from './utils'
// TODO: unify widget config types and use it in index too
interface Props {
    widgetConfig: JsonConfig
    changeConfig: (configName: string, newValue: any) => void
}

function WBSChartOptions(props: Props): React.ReactElement {
    const zoomStatus = props.widgetConfig.zoomStatus

    function onChangeRadio(type: ZoomStatus): void {
        props.changeConfig('zoomStatus', type)
    }

    return (
        <Fields name={'channels'}>
            <div className="WBSChartOptions--syncTooltipToggle">
                <ActionToggle
                    active={props.widgetConfig.syncTooltip}
                    onChange={(): void => props.changeConfig('syncTooltip', !props.widgetConfig.syncTooltip)}
                />
                <span>{i18n('Sync tooltip')}</span>
            </div>
            <ZoomOptionsGroup
                className="WBSChartOptions--zoomOptions"
                role="radiogroup"
                aria-labelledby="WBSChartOptions--zoomOptions__groupLabel"
                id="rg2"
            >
                <h3 id="WBSChartOptions--zoomOptions__groupLabel">{i18n('Zoom Options')}</h3>
                <div>
                    <input
                        type="radio"
                        id={zoomOptions.zoomEntireWell}
                        name="zoomOptions"
                        value="Entire Well"
                        checked={zoomStatus === zoomOptions.zoomEntireWell}
                        onClick={() => onChangeRadio(zoomOptions.zoomEntireWell)}
                    />
                    <label htmlFor={zoomOptions.zoomEntireWell}>{i18n('Entire Well')}</label>
                </div>
                <div>
                    <input
                        type="radio"
                        id={zoomOptions.followBitDepth}
                        name="zoomOptions"
                        value="Follow Bit Depth"
                        checked={zoomStatus === zoomOptions.followBitDepth}
                        onClick={() => onChangeRadio(zoomOptions.followBitDepth)}
                    />

                    <label htmlFor={zoomOptions.followBitDepth}>{i18n('Follow Bit Depth')}</label>
                </div>
                <div>
                    <input
                        type="radio"
                        id={zoomOptions.free}
                        name="zoomOptions"
                        value="Free"
                        checked={zoomStatus === zoomOptions.free || !zoomStatus}
                        onClick={() => onChangeRadio(zoomOptions.free)}
                    />
                    <label htmlFor={zoomOptions.free}>{i18n('Free')}</label>
                </div>
            </ZoomOptionsGroup>
            <AssetSelector label={'Asset'} editorOnly={true} />
            <ObjectSelector objectType={'trajectory'} label={i18n('Trajectory')} />
            <ObjectSelector objectType={'mudLog'} label={'Mudlog'} />
        </Fields>
    )
}

export default WBSChartOptions

const ZoomOptionsGroup = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 10px 25px;
    h3 {
        width: 100%;
        margin-bottom: 5px;
        font-size: 14px;
        font-weight: 600;
    }
    > div {
        display: flex;
        margin-bottom: 5px;
        label {
            margin-left: 3px;
        }
    }
`
